<template>
  <!-- 多文件上传 -->
  <el-dialog :title="`多文件上传`" :width="pda.status ? '90%' : '800px'" :visible.sync="show" :append-to-body="true">
    <div class="file-upload">
      <el-upload
        ref="upload"
        action="#"
        :accept="type"
        :auto-upload="false"
        :file-list="list"
        :list-type="'text'"
        :on-change="fileChange"
        :limit="limit"
        multiple>
        <div slot="trigger" class="mb10">
          <!-- 选择文件 -->
          <el-button type="primary" size="small" icon="el-icon-plus">{{`请选择文件`  }}</el-button>
        </div>
        <!-- 请选择文件并上传，支持的类型为 -->
        <div v-show="listEmpty" class="describe">
          请选择文件并上传，支持的类型为 ( {{type}} ) 
        </div>
        <div v-show="!listEmpty" slot="file" slot-scope="{file}">
          <div class="d-flex between">
            <span @click="handlePreview(file)" class="d-flex name-wrap">
              <img :src="file.url" alt="" style="display:none">
              <span class="file-name" :title="file.name">{{file.name}}</span>
              <span class="file-progress">{{`${percent(file.percentage)}%`}}</span>
            </span>
            <i class="el-icon-error ml10 close-icon" @click="handleRemove(file)"></i>
          </div>
        </div>
      </el-upload>
      <div class="d-flex between mt25">
        <el-button
          icon="el-icon-refresh"
          size="small"
          type="danger"
          :disabled="listEmpty"
          v-on:click.stop="reset">
          <!-- 清空 -->
          清空
        </el-button>
        <el-button
          icon="el-icon-upload"
          size="small"
          type="warning"
          :disabled="listEmpty"
          v-on:click.stop="upload">
          <!-- 上传 -->
          上传
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MultiFileUpload',
  props: {
    type: {
      type: String,
      default: '*', // video/* audio/* image/* .pdf .xls .doc
    },
    limit: {
      type: Number,
      default: 999,
    },
  },
  computed: {
    ...mapGetters(['pda'])
  },
  data() {
    return {
      show: false,
      list: [],
      disabled: false,
      listEmpty: true,
      previewUrl: null
    }
  },
  methods: {
    open() {
      this.reset()
      this.show = true
    },
    close() {
      this.show = false
    },
    percent(p) {
      return p.toFixed(2)*100
    },
    fileChange() {
      this.listEmpty = this.$refs.upload.uploadFiles.length === 0
    },
    revokeUrl() {
      // 释放预览url
      if (this.previewUrl && this.previewUrl.indexOf('blob:') === 0) {
        URL.revokeObjectURL(this.previewUrl)
      }
    },
    handlePreview(file) {
      // 预览待上传文件
      this.revokeUrl()

      this.previewUrl = URL.createObjectURL(file.raw)
      window.open(this.previewUrl, '_blank')
    },
    async upload() {
      // 按顺序上传
      const files = this.$refs.upload.uploadFiles;
      const result = []
      if (files.length === 0) {
        // this.$message.error('请选择文件')
        this.$message.error(`请选择文件`)
        return
      }
      for (const file of files) {
        file.filename = file.name

        const res = await this.$upload.start(file)
        result.push(res)
      }
      
      this.complete(result)
    },
    complete(list) {
      this.$emit('complete', list)
      this.close()
      this.$nextTick(() => {
        this.reset()
      })
    },
    handleRemove(file) {
      const list = this.$refs.upload.uploadFiles
      list.forEach((i, d) => {
        if (file.uid === i.uid) {
          list.splice(d, 1)
        }
      })

      this.listEmpty = this.$refs.upload.uploadFiles.length === 0
    },
    reset() {
      this.list = []
      this.listEmpty = true
      this.revokeUrl()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/common.scss';
  .file-upload {
    /deep/ .el-dialog {
      width: 820px;
    }
    /deep/ .el-dialog__body {
      padding-top: 0 !important;
    }
  }
  .img-viewer {
    /deep/ .el-dialog {
      margin-top: 4vh !important;
    }
  }
  .describe {
    padding: 4px 0;
    color: gray;
  }
  .name-wrap {
    overflow: hidden;
  }
  .file-name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }
  .file-progress{
    padding: 0 0 0 20px;
    color: $main_color_deep;
  }
  .close-icon {
    cursor: pointer;
  }
</style>